import React from 'react';
import {withStyles, makeStyles} from '@material-ui/core/styles';
import {InputBase, FormControl, InputLabel, InputAdornment, IconButton, FormHelperText, Select, MenuItem, Checkbox, ListItemText, TextareaAutosize} from '@material-ui/core';
import {Visibility, VisibilityOff, Search, Close} from '@material-ui/icons';
import { RaymanUser } from './RaymanUser';
import {Text} from 'components/core';
import { ColorPicker as OriginalColorPicker } from 'material-ui-color';
import clsx from 'clsx';
import { ProcedureStepFilesCtx } from 'components/dataProviders/procedureSteps';
import ProceduresPanel from 'sections/procedures/main/panel';

const styleConstructor = (theme) => ({
  root: {
    margin: 0,
    color: theme.palette.input.foreground,
    backgroundColor: theme.palette.input.background,
    border: `2px solid ${theme.palette.input.background}`,  
    boxSizing: "border-box",
    height: 40,
    borderRadius: 8,
    fontSize: 16,
    transition: theme.transitions.create(['border-color']),
  '&.Mui-focused':
  {
    borderColor: theme.palette.primary.main,
  }
},
formComponent: {
  width: '100%',
  display: 'inline-flex',
  flexDirection: 'column',
  verticalAlign: 'top',

  'label + &': {
    marginTop: theme.spacing(3),
  }
},
compose: {
  display: 'inline-flex',
  flexDirection: 'row'
},
timespan: {
  lineHeight: '40px',
  '& > *': {
    margin: '0 10px',
    width: 75
  }
},
input: {
  borderRadius: 8,
  padding: "0 10px",
  margin: 0,
  boxShadow: `0 0 0px 1000px ${theme.palette.input.background} inset`,
  '&::placeholder':
  {
    color: theme.palette.input.placeholder
  },
},
textArea: {
  minHeight: 120
},
colorPicker: {
  '& > div':
  {
    display: "inline-block",
    float: "left"
  }
},
multiselectorItem: {
  display: "inline-block",
  backgroundColor: theme.palette.background.paper,
  padding: "3px 10px",
  borderRadius: 10,
  margin: "3px 5px",
  boxShadow: "0 0 3px #ccc"
},
selectorPlaceholder: {
  color: theme.palette.input.placeholder
}
// icon: {
//   color: theme.palette.text.primary
// }
});

const styles = makeStyles(styleConstructor, {name:"RaymanInputBase"});

const RaymanInput = withStyles((theme) => (
  {
    root: {
      margin: 0,
      color: theme.palette.input.foreground,
      backgroundColor: theme.palette.input.background,
      border: `2px solid ${theme.palette.input.background}`,  
      boxSizing: "border-box",
      height: 40,
      borderRadius: 8,
      fontSize: 16,
      transition: theme.transitions.create(['border-color']),
    '&.Mui-focused':
    {
      borderColor: theme.palette.primary.main,
    }
    },
    input: {
      borderRadius: 8,
      padding: "0 10px",
      margin: 0,
      boxShadow: `0 0 0px 1000px ${theme.palette.input.background} inset`,
      '&::placeholder':
      {
        color: theme.palette.input.placeholder
      },
    },
  }), {name: "RaymanInputBase"})(InputBase);


  const RaymanLabel = withStyles((theme) => ({
    root: {
      fontWeight: 500,
      color: theme.palette.text.primary
    },
  }), {name: "RaymanLabelBase"})(InputLabel);

  const InputIconButton = withStyles((theme) => ({
    root:
    {
      padding: 6,
      margin: 6,
      color: theme.palette.input.placeholder
    }
  }), {name: "RaymanInputIconButton"})(IconButton);

  const InputSearchIcon = withStyles((theme) => ({
    root:
    {
      // padding: 6,
      margin: 6,
      color: theme.palette.input.placeholder
    }
  }), {name: "RaymanInputIconButton"})(Search);


function FormComponent(props)
{
  const classes = styles();

  return <FormControl fullWidth error={props.error}>
    {props.label ? <RaymanLabel shrink>
          {props.label}
    </RaymanLabel> : null}
    <div className={classes.formComponent}>{props.children}</div>
    {props.error ? <FormHelperText>{props.error}</FormHelperText> : null}
  </FormControl>
}
  

function TextField(props)
{
    return <FormComponent {...props}>
        <RaymanInput {...props}/>
        </FormComponent>
}

function TextArea(props)
{
    const classes = styles();
    return <FormComponent {...props}>
        <RaymanInput multiline rows={5} rowsMax={6} className={clsx(classes.textArea, props.className)} {...props} />
        </FormComponent>
}

function PasswordField({onChange, ...props})
{

  const [values, setValues] = React.useState({
    password: '',
    showPassword: false,
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
    if(onChange) onChange(event);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return <FormComponent {...props}>
  <RaymanInput
    id="standard-adornment-password"
    type={values.showPassword ? 'text' : 'password'}
    value={values.password}
    onChange={handleChange('password')}
    endAdornment={
      <InputAdornment position="end">
        <InputIconButton
          aria-label="toggle password visibility"
          onClick={handleClickShowPassword}
          onMouseDown={handleMouseDownPassword}
        >
          {values.showPassword ? <Visibility /> : <VisibilityOff />}
        </InputIconButton>
      </InputAdornment>
    }
    {...props}
  />
</FormComponent>
}

function SearchField({onChange = () => {}, ...props})
{

  const [content, setContent] = React.useState('');

  const handleChange = (prop) => (event) => {
    setContent(event.target.value);
    if(onChange) onChange(event.target.value);
  };

  const handleReset = () => {
    setContent('');
    if(onChange) onChange('');
  };

  return <RaymanInput
    id="standard-adornment-password"
    type='text'
    value={content}
    onChange={handleChange('password')}
    placeholder="Buscar"
    startAdornment={
      <InputAdornment position="start">
        <InputSearchIcon />
      </InputAdornment>
    }
    endAdornment={
      content ?
      <InputAdornment position="end">
        <InputIconButton
          onClick={handleReset}
        >
          <Close />
        </InputIconButton>
      </InputAdornment>
      : null
    }
    {...props}
  />
}

function ColorPicker(props)
{
  const classes = styles();
  //const [color, setColor] = React.useState(props.value ? "#"+props.value : '#333333');
  const tempColor = React.useRef(props.value ? "#"+props.value : '#333333');

  let pickTimeout = 0;

  React.useEffect(function setColorValue(){
    if(props.value) tempColor.current = "#"+props.value; //setColor("#"+props.value);
  }, [props.value]);

  const handleColorChange = (color) => 
  {
    tempColor.current = color;
    if(pickTimeout) clearTimeout(pickTimeout);
    pickTimeout = setTimeout(() => {
      //setColor(color);
      if(props.onChange) props.onChange(color.hex);
  }, 50);
    // if(props.onChange) props.onChange(color.hex);
  }

  return <FormComponent {...props}>
        <div className={clsx(classes.root, classes.colorPicker)}>
          <OriginalColorPicker disableTextfield hideTextfield disableAlpha value={tempColor.current} onChange={handleColorChange} />
          <Text style={{lineHeight: "40px"}}>
            {tempColor.current.hex ? "#"+tempColor.current.hex : typeof(tempColor.current) === "string" ? tempColor.current : "Sin color"}
          </Text>
        </div>
        </FormComponent>
}


function Selector({items, onChange = (evt)=>{}, value = '', multiple = false, ...props})
{
  const classes = styles();
  const handleChange = (evt) =>
  {
    onChange(evt);
  }

  function RenderValue(selected)
  {
      if(!selected || selected.length === 0) return <span className={classes.selectorPlaceholder}>{props.placeholder ? props.placeholder : ""}</span>;

      if(multiple)
      {
        let selectedItems = items.filter((item) => (selected.indexOf(item.value) > -1)).map((item) => item.content);
        if(selectedItems.length === 1) return <span className={classes.multiselectorItem}>{selectedItems[0]}</span>

        else return selectedItems.reduce((prev, curr) => {

          if(prev === null) return [<span className={classes.multiselectorItem}>{curr}</span>];

          if(!Array.isArray(prev)) prev = [<span className={classes.multiselectorItem}>{prev}</span>];

          return [...prev, <span className={classes.multiselectorItem}>{curr}</span>];
        });

      }
      else
      {
        let render = undefined;
        items.forEach((item) => {
          if(item.value === selected) render = item.content;
        });
        return render;
      }
  }

    return <FormComponent {...props}>
        <Select 
        {...props}
        multiple={multiple}
        value={value}
        onChange={handleChange}
        input={<RaymanInput />}
        displayEmpty
        renderValue={RenderValue}
        >
          {items.map((item) => {
            return <MenuItem key={item.value} value={item.value}>
              {multiple ? <>
                <Checkbox color="primary" checked={value.indexOf(item.value) > -1} />
                <ListItemText primary={item.content} />
              </> :
              item.content
              }
            </MenuItem>
          })}
        </Select>
       </FormComponent>
}

function TagSelector({items, onChange = null, value = [], ...props})
{
    return <Selector multiple items={items} onChange={onChange} value={value} {...props} />
}


function Timespan({onChange, value, ...props})
{
  const classes = styles();
  // const [value, setValue] = React.useState({mins: props.value - Math.floor(props.value/60), hours: Math.floor(props.value/60), time: props.value});
  const [internalValue, setInternalValue] = React.useState({mins: 0, hours: 0, time: 0});

  React.useEffect(function setValue() {
    if(!value) return;
    let tmpValue = {};
    tmpValue.time = value / 60;
    tmpValue.hours = Math.floor(tmpValue.time / 60);
    tmpValue.mins = tmpValue.time - (tmpValue.hours * 60);
    setInternalValue(tmpValue);
  }, [value]);

  const handleChangeHours = (event) => {
    let val = parseInt(event.target.value);
    if(!val && event.target.value === "") val = 0;
    if(val === undefined || val < 0) return;

    let tmpValue = {...internalValue};
    tmpValue.hours = val;
    tmpValue.time = tmpValue.hours*60+tmpValue.mins;
    setInternalValue(tmpValue);

    if(onChange) onChange(tmpValue.time * 60);
  };

  const handleChangeMinutes = (event) => {
    let val = parseInt(event.target.value);
    if(!val && event.target.value === "") val = 0;
    if(val === undefined || val < 0) return;
    let tmpValue = {...internalValue};
    tmpValue.mins = val;
    tmpValue.time = tmpValue.hours*60+tmpValue.mins;

    setInternalValue(tmpValue);
    if(onChange) onChange(tmpValue.time * 60);
  };

  return <FormComponent {...props}>
    <div className={clsx(classes.compose, classes.timespan)}>
      <FormControl>
  <RaymanInput
    // {...props}
    type="number"
    onChange={handleChangeHours}
    min={0}
    max={99}
    step={1}
    value={internalValue.hours}
  /></FormControl>
  <span>horas</span>
  <FormControl><RaymanInput
    // {...props}
    type="number"    
    onChange={handleChangeMinutes}
    min={0}
    max={59}
    step={1}
    value={internalValue.mins}
  /></FormControl>
  <span>minutos</span>
  </div>
</FormComponent>
}

export {TextField, PasswordField, SearchField, Selector, TagSelector, ColorPicker, TextArea, FormComponent, Timespan, InputIconButton};